import type { SideNavProps } from './side-nav';
import { SideNav } from './side-nav';

export function SecondaryLeftNav({ items }: { items: SideNavProps['items'] }) {
  return (
    <SideNav isExpanded={true} shouldExpandOnHover={false} items={items} expandedWidth={220} style={{ zIndex: 20 }} />
  );
}
